export const TipoPlantilla = {
  SMS: 1,
  Email: 2,
  Llamada: 3,
};

export const TipoRespuestas = {
  NoAplica: 0,
  EmailLogin: 1,
  EmailSpecific: 2,
};

export const PlantillaId = {
  PlantillaEspecifica: 1002,
};

export const DestinoInt = {
  GrupoUser: "1",
};

export const DestinoExt = {
  UserContactoProceso: "1",
  Procesos: "2",
  UserAsignado: "3",
};

export const TipoText = {
  Plantilla: 1,
  Escrito: 2,
};

export const TipoEnvio = {
  Online: 1,
  Programado: 2,
};

export const TipoDisparador = {
  Pagina: 1,
  Subrutina: 2,
  Evento: 3,
  NotificationProgramada: 4,
};